export default "__VITE_ASSET__79a12e84__"